import { getMonthDuration } from 'apps/fleet-planner/utils/dedicatedLanesHelpers'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { MARKETPLACE_EQUIPMENT_TYPES } from 'constants/equipment'
import { IDedicatedLanesOfferCardProps } from './types'

export const getDedicatedLaneInfo = (
  dedicatedLane: DedicatedLanesResponse
): IDedicatedLanesOfferCardProps => {
  const {
    delivery,
    endDate = '',
    equipment,
    id,
    loadingMethod = '',
    pickup,
    startDate = '',
    volume,
  } = dedicatedLane || {}
  const { parentId: equipmentId } = equipment || {}
  const equipmentName = MARKETPLACE_EQUIPMENT_TYPES.find(eq => eq.id === equipmentId)?.name || ''
  const { city: pickupCity, stateCode: pickupStateCode } = pickup || {}
  const { city: deliveryCity, stateCode: deliveryStateCode } = delivery || {}
  const pickupLoadingMethod = loadingMethod.split('-')[0] || ''
  const deliveryLoadingMethod = loadingMethod.split('-')[1] || ''

  const monthDuration = getMonthDuration(dedicatedLane)

  return {
    equipmentName,
    pickupCity,
    pickupStateCode,
    pickupLoadingMethod,
    deliveryCity,
    deliveryStateCode,
    deliveryLoadingMethod,
    monthDuration,
    startDate,
    endDate,
    id,
    volume,
  }
}

export const parseLoadingMethod = (loadingMethod: string): string => {
  switch (loadingMethod) {
    case 'live':
      return 'Live Load'
    case 'drop':
      return 'Drop Trailer'
    default:
      return ''
  }
}
